import en from './en-US.json'
import es from './es.json'
import cn from './cn.json'

export const defaultLocale = 'en'
export const messages = { "en-US": en, "en": en, "es": es, "es-US": es, "es-MX": es, zh: cn, "zh-CN": cn, cn: cn, "zh-HK": cn }
